import {
  FETCH_LATEST_SEARCH_REINDEX,
  FetchLatestSearchReindexSuccessAction,
  SEARCH_REINDEX_COMPLETED,
  SEARCH_REINDEX_LATEST,
  SEARCH_REINDEX_STARTED,
  SUBMIT_SEARCH_REINDEX,
  SearchReindexActionTypes,
  SearchReindexCompletedAction,
  SearchReindexLatestAction,
  SearchReindexStartedAction,
  SearchReindexState,
  SubmitSearchReindexSuccessAction,
} from "./SearchReindexTypes";

const initialState: SearchReindexState = {
  submitting: false,
  running: null,
  lastResult: null,
  latest: undefined,
};

export const SearchReindexReducer = (
  state: SearchReindexState = initialState,
  action: SearchReindexActionTypes,
): SearchReindexState => {
  switch (action.type) {
    case SUBMIT_SEARCH_REINDEX.REQUEST:
      return { ...state, submitting: true };
    case SUBMIT_SEARCH_REINDEX.FAILURE:
      return { ...state, submitting: false };
    case SUBMIT_SEARCH_REINDEX.SUCCESS: {
      const { payload } = action as SubmitSearchReindexSuccessAction;
      // The started event carries the server's start time; keep it if it
      // arrived before the 202.
      if (state.running?.requestId === payload.requestId) {
        return { ...state, submitting: false };
      }
      return {
        ...state,
        submitting: false,
        running: {
          requestId: payload.requestId,
          storeId: payload.storeId,
          startedAt: new Date().toISOString(),
        },
      };
    }
    case SEARCH_REINDEX_STARTED:
      return {
        ...state,
        running: (action as SearchReindexStartedAction).payload,
      };
    case SEARCH_REINDEX_COMPLETED: {
      const { payload } = action as SearchReindexCompletedAction;
      if (state.running?.requestId !== payload.requestId) {
        return state;
      }
      return { ...state, running: null, lastResult: payload };
    }
    case SEARCH_REINDEX_LATEST:
      return {
        ...state,
        latest: (action as SearchReindexLatestAction).payload,
      };
    case FETCH_LATEST_SEARCH_REINDEX.SUCCESS:
      return {
        ...state,
        latest:
          (action as FetchLatestSearchReindexSuccessAction).payload?.latest ??
          null,
      };
    default:
      return state;
  }
};
